#import "../fragments/automation-conditions-fragment.graphql"

fragment ClosedLeadSlackMessage on ClosedLeadSlackMessage {
    id
    channelId
    conditions {
        ...Condition
    }
    slackChannel {
        display
        externalId
        name
    }
}
